import { Box, Snackbar, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import NavbarSpacer from "components/NavbarSpacer";
import Account from "./Account.jsx";
import Calendar from "./Calendar.jsx";
import Help from "./Help.jsx";
import Navbar from "./navbar.jsx";
import View from "./View.jsx";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "state";
import { tokens } from "theme.js";
import "transition.css";

const Dashboard = () => {
    const mode = useSelector((state) => state.mode);
    const colors = tokens(mode);
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
    const [tab, setTab] = useState(1);
    const dispatch = useDispatch();
    const snackbars = useSelector((state) => state.snackbars);
    const [emblaRef, emblaApi] = useEmblaCarousel({
        axis: "x",
        draggable: false,
    });
    document
        .querySelector("meta[name='theme-color']")
        .setAttribute("content", colors.neutralLight[100]);
    const viewRef = useRef();
    const calendarRef = useRef();
    const helpRef = useRef();
    const accountRef = useRef();
    const [emblaContainerRef, setEmblaContainerRef] = useState(calendarRef);

    const handleTabChange = (event, newValue) => {
        switch (newValue) {
            case 0:
                setEmblaContainerRef(viewRef);
                break;
            case 1:
                setEmblaContainerRef(calendarRef);
                break;
            case 2:
                setEmblaContainerRef(helpRef);
                break;
            case 3:
                setEmblaContainerRef(accountRef);
                break;
            default:
                break;
        }
        setTab(newValue);
    };

    useEffect(() => {
        const onSelect = () => {
            setTab(emblaApi.selectedScrollSnap());
        };
        if (emblaApi) {
            emblaApi.scrollTo(tab);
            emblaApi.on("select", onSelect); // Add event listener
        }
    }, [emblaApi, tab]);

    return (
        <Box
            className="fadeIn"
            width="100vw"
            height={isNonMobileScreens ? "100vh" : "100vh"}
            sx={{ touchAction: "pan-y" }}
        >
            <Navbar
                tab={tab}
                handleTabChange={handleTabChange}
                emblaRef={emblaContainerRef}
            />
            {isNonMobileScreens ? (
                <div
                    className="embla"
                    ref={emblaRef}
                    style={{
                        overflowX: "hidden",
                        height: "100%",
                        touchAction: "pan-y",
                    }}
                >
                    <div
                        className="embla__container"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            height: "100%",
                            touchAction: "pan-y",
                        }}
                    >
                        <div
                            className="embla__slide"
                            key="0"
                            ref={viewRef}
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                minWidth: 0,
                                touchAction: "pan-y",
                            }}
                        >
                            <View />
                        </div>
                        <div
                            className="embla__slide"
                            key="1"
                            ref={calendarRef}
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                touchAction: "pan-y",
                                minWidth: 0,
                            }}
                        >
                            <Calendar />
                        </div>
                        <div
                            className="embla__slide"
                            key="2"
                            ref={helpRef}
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                touchAction: "pan-y",
                                minWidth: 0,
                            }}
                        >
                            <Help />
                        </div>
                        <div
                            className="embla__slide"
                            key="3"
                            ref={accountRef}
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                touchAction: "pan-y",
                                minWidth: 0,
                            }}
                        >
                            <Account />
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className="embla"
                    ref={emblaRef}
                    style={{
                        overflowX: "hidden",
                        height: "100%",
                        touchAction: "pan-y",
                    }}
                >
                    <div
                        className="embla__container"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            height: "100%",
                            touchAction: "pan-y",
                        }}
                    >
                        <div
                            className="embla__slide"
                            key="0"
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                paddingBottom: "60px",
                                boxSizing: "border-box",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                minWidth: 0,
                                touchAction: "pan-y",
                            }}
                        >
                            <View />
                        </div>
                        <div
                            className="embla__slide"
                            key="1"
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                paddingBottom: "60px",
                                boxSizing: "border-box",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                touchAction: "pan-y",
                                minWidth: 0,
                            }}
                        >
                            <Calendar />
                        </div>
                        <div
                            className="embla__slide"
                            key="2"
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                paddingBottom: "60px",
                                boxSizing: "border-box",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                touchAction: "pan-y",
                                minWidth: 0,
                            }}
                        >
                            <Help />
                        </div>
                        <div
                            className="embla__slide"
                            key="3"
                            style={{
                                overflowY: "auto",
                                paddingTop: "70px",
                                paddingBottom: "60px",
                                boxSizing: "border-box",
                                flex: "0 0 100%",
                                display: "flex",
                                justifyContent: "center",
                                touchAction: "pan-y",
                                minWidth: 0,
                            }}
                        >
                            <Account />
                        </div>
                    </div>
                </div>
            )}
            <Snackbar
                open={snackbars.eventTypeCopied}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(
                        hideSnackbar({
                            snackbar: "eventTypeCopied",
                        })
                    );
                }}
                message="Link copied!"
            />
            <Snackbar
                open={snackbars.eventTypeDeleted}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(
                        hideSnackbar({
                            snackbar: "eventTypeDeleted",
                        })
                    );
                }}
                message="Event type deleted!"
                // action={} undo
            />
            <Snackbar
                open={snackbars.eventTypeEdited}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(
                        hideSnackbar({
                            snackbar: "eventTypeEdited",
                        })
                    );
                }}
                message="Event type saved!"
                // action={} undo
            />
            <Snackbar
                open={snackbars.eventTypeAdded}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(
                        hideSnackbar({
                            snackbar: "eventTypeAdded",
                        })
                    );
                }}
                message="Event type added!"
            />

            <Snackbar
                open={snackbars.viewDeleted}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(
                        hideSnackbar({
                            snackbar: "viewDeleted",
                        })
                    );
                }}
                message="View deleted!"
                // action={} undo
            />
            <Snackbar
                open={snackbars.viewEdited}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(
                        hideSnackbar({
                            snackbar: "viewEdited",
                        })
                    );
                }}
                message="View saved!"
                // action={} undo
            />
            <Snackbar
                open={snackbars.viewAdded}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(hideSnackbar({ snackbar: "viewAdded" }));
                }}
                message="View added!"
            />
            <Snackbar
                open={snackbars.eventAccepted}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(hideSnackbar({ snackbar: "eventAccepted" }));
                }}
                message="Event accepted!"
            />
            <Snackbar
                open={snackbars.eventDenied}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(hideSnackbar({ snackbar: "eventDenied" }));
                }}
                message="Event denied."
            />
            <Snackbar
                open={snackbars.eventCanceled}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(hideSnackbar({ snackbar: "eventCanceled" }));
                }}
                message="Event canceled."
            />
            <Snackbar
                open={snackbars.profileSaved}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(hideSnackbar({ snackbar: "profileSaved" }));
                }}
                message="Profile saved."
            />
            <Snackbar
                open={snackbars.passwordChanged}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(hideSnackbar({ snackbar: "passwordChanged" }));
                }}
                message="Password changed."
            />
            <Snackbar
                open={snackbars.googleAccountUnlinked}
                autoHideDuration={4000}
                onClose={() => {
                    dispatch(
                        hideSnackbar({ snackbar: "googleAccountUnlinked" })
                    );
                }}
                message="Your google account has been unlinked."
            />
        </Box>
    );
};

export default Dashboard;
